import Imgix from './Imgix';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class LightboxGallery {
    constructor() {
        this.imgixInstance = new Imgix(); // register new Imgix instance

        this.currentImages = [];
        this.imagesRequested = false
        this.lightboxContainer = document.getElementById('lightbox-gallery');
        this.swiper = null;

        this.init();
    }

    init() {
        // Bind close functionality to the close button
        this.lightboxContainer.querySelector('.c-lightbox__close-button').addEventListener('click', () => this.closeLightbox());

        // Find all galleries and initialize event listeners for images
        document.querySelectorAll('[data-module="lightbox-gallery"]').forEach((gallery) => {
            const images = gallery.querySelectorAll('img');
            images.forEach((img, index) => {
                img.setAttribute('data-index', index);
                img.addEventListener('click', (e) => this.openLightbox(gallery, e.target));
            });
        });

        // Close the modal when clicking outside the content area
        this.lightboxContainer.addEventListener('click', (event) => {
            const rect = this.lightboxContainer.getBoundingClientRect();
            const isInDialog = (event.clientX >= rect.left && event.clientX <= rect.right &&
                                event.clientY >= rect.top && event.clientY <= rect.bottom);
            if (!isInDialog) {
                this.closeLightbox();
            }
        });

        document.body.addEventListener('keydown', (e) => {
            if (e.key == "Escape") {
                this.closeLightbox();
            }
        });
    }

    openLightbox(gallery, clickedImage) {
        const images = Array.from(gallery.querySelectorAll('img'));
        this.currentImages = images.map((img) => img.dataset.src);

        // Render the lightbox with the current gallery's images
        this.renderLightbox();

        // Start the swiper on the clicked image
        const clickedIndex = clickedImage.getAttribute('data-index');
        this.swiper.slideToLoop(parseInt(clickedIndex, 10), 0); // Start at the clicked image in the loop

        // Open the modal
        this.lightboxContainer.showModal(); // Use showModal() to open as a modal dialog
        document.body.classList.add('lightbox-open');
    }

    renderLightbox() {
        // Initialize or reinitialize Swiper with proper options
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }

        const swiperWrapper = this.lightboxContainer.querySelector('.swiper-wrapper');
        swiperWrapper.innerHTML = '';

        this.currentImages.forEach((src) => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');

            slide.innerHTML = `<img class="imgix-fluid / img-fit o-image" data-src="${src}" />`;
            swiperWrapper.appendChild(slide);
        });

        this.swiper = new Swiper('.swiper', {
            modules: [Navigation],
            loop: true,
            slidesPerView: 1,
            loopedSlides: this.currentImages.length,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                afterInit: (swiper) => {
                    if(this.imagesRequested) return;

                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent("ajaxModalHasLoaded"));
                    }, 150);

                    this.imagesRequested = true;
                }
            },
        });
    }

    closeLightbox() {
        document.body.classList.remove('lightbox-open');
        this.lightboxContainer.close(); // Use the close() method to close the dialog
        this.imagesRequested = false;
        setTimeout(() => {
            this.swiper.destroy(true, true); // Destroy Swiper to reset it when the lightbox closes
        }, 100);
    }
}
